module.exports = __webpack_public_path__ + "static/media/Scizor_gaussian2.7bc07f13.png";